import moment from "moment";
export default {
  props: {
    contabile: Object,
  },
  data() {
    return {
      dialogElimina: false,
      loadingElimina: false,
      dialogConfermaSaldato: false,
      nuovoSaldato: null,
      saldato: this.contabile.saldato,
      alertError: false,
    };
  },
  computed: {
    cliente() {
      if (!this.contabile || !this.contabile.cliente) return null;
      return this.$store.getters.get_cliente_by_iva(this.contabile.cliente);
    },
    dataFormatted() {
      if (!this.contabile || !this.contabile.ts) return "";
      return moment.unix(this.contabile.ts).format("dddd DD MMMM YYYY");
    },
    ordine() {
      return this.$store.getters.get_ordine_by_id(this.contabile.id_ordine);
    },
  },
  methods: {
    toggle_saldato(instant) {
      if (this.contabile && this.contabile.fake) return; // ignora placeholder
      this.dialogConfermaSaldato = true;
      if (instant) {
        this.saldato = !this.saldato;
        this.setSaldato(this.saldato);
      }
    },
    async eliminaContabile() {
      if (this.contabile && this.contabile.fake) return; // ignora placeholder
      this.loadingElimina = true;
      await this.$store.dispatch("delete_contabile", this.contabile.id);
      this.dialogElimina = false;
      this.loadingElimina = false;
      this.$emit("new_insert");
    },
    async confermaSaldato() {
      if (this.contabile && this.contabile.fake) return; // ignora placeholder
      this.saldato = !this.saldato;
      this.setSaldato(this.saldato);
      this.dialogConfermaSaldato = false;
    },
    annullaSaldato() {
      this.dialogConfermaSaldato = false;
    },
    setSaldato(val) {
      if (this.contabile && this.contabile.fake) return; // ignora placeholder
      this.$store
        .dispatch("toggle_contabile_saldato", {
          id: this.contabile.id,
          stato: val,
        })
        .catch(() => {
          this.alertError = true;
          this.saldato = !this.saldato;
        });
    },
    formatData(ts) {
      if (ts) {
        return moment.unix(ts).format("DD-MM-YYYY");
      }
      return "";
    },
    openDettaglioOrdine() {
      if (!this.ordine) {
        this.$store
          .dispatch("fetch_ordine_by_id", this.contabile.id_ordine)
          .then(() => {
            this.$refs.ordineDialog.open();
          });
      } else {
        this.$refs.ordineDialog.open();
      }
    },
    async updateContabile() {
      // Notifica il parent di aggiornare la lista
      this.$emit("new_insert");
      // Attendi il prossimo tick così il parent finisce refreshList e il ref è di nuovo montato
      await this.$nextTick();
      if (
        this.$refs.contabileOrdineRef &&
        this.$refs.contabileOrdineRef.loadOrdine
      ) {
        this.$refs.contabileOrdineRef.loadOrdine();
      }
    },
  },
};
